import { isMobile } from "react-device-detect";
import { v4 as uuidv4 } from "uuid";

export function isMobileDevice() {
  return isMobile;
}

export function isTouchDevice() {
  if ("ontouchstart" in window || navigator.maxTouchPoints > 0) return true;
  return false;
}

export function generateUUID() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  } else {
    return uuidv4();
  }
}

export function getBrowserDiagnostics() {
  const nav = navigator as any;
  // Safe platform detection
  const platform = nav.userAgentData?.platform || nav.platform || "unknown";
  // Basic browser info
  const browserInfo = {
    userAgent: navigator.userAgent,
    platform,
    language: navigator.language,
    online: navigator.onLine,
  };
  // Network Information API (if available)
  const connection = nav.connection || nav.mozConnection || nav.webkitConnection;
  const networkInfo = connection
    ? {
        effectiveType: connection.effectiveType,
        downlink: connection.downlink,
        rtt: connection.rtt,
        saveData: connection.saveData,
      }
    : { effectiveType: "unknown" };
  return { ...browserInfo, ...networkInfo };
}
